import React from 'react';
import styled from 'styled-components';
import {
  BenchMark,
  BrandAstraNavigator,
  EnterPriseCompatibility,
  GenAI,
  HolisticView,
  Multichannel,
  Publishing,
  UnderstandLanguage,
  WhyTrends,
} from '../../../Common/SvgIcon/CommonSvgIcons';
import { Helmet } from 'react-helmet-async';

const sizes = {
  mobileM: '375px',
  mobileL: '425px',
  tablet: '768px',
  desktop: '1800px',
};

export const device = {
  tablet: `(max-width: ${sizes.tablet})`,
  desktop: `(min-width: ${sizes.desktop})`,
};

const Wrapper = styled.div`
  margin-top: 60px;
  background: #9dc8bb;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 40px;
  align-items: center;
  padding-bottom: 60px;
`;
const Title = styled.div`
  font-family: Inter;
  font-weight: 600;
  font-size: 32px;
  padding: 60px;
  padding-bottom: unset;
  text-align: center;
  vertical-align: middle;
  background-image: linear-gradient(90deg, #063257 0%, #006867 100%);
  color: transparent;
  background-clip: text;
  @media only screen and ${device.tablet} {
    font-size: 28px;
    padding-right: unset;
    padding-left: unset;
    padding-bottom: unset;
  }
`;
const GridContainer = styled.div`
  max-width: 1140px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  @media only screen and ${device.tablet} {
    max-width: 345px;
  }
`;
const IndividualGrid = styled.div`
  width: 300px;
  height: 180px;
  margin-top: 20px;
  gap: 16px;
  border-radius: 15px;
  padding: 30px;
  background: radial-gradient(
    105.54% 261.59% at -5.62% 0%,
    rgba(192, 229, 108, 0.5) 0%,
    rgba(246, 251, 233, 0.8) 100%
  );
  display: flex;
  flex-direction: column;
  align-itens: start;
  box-shadow: 4px 4px 4px 0px #07234b40;

  backdrop-filter: blur(11.300000190734863px);
  @media only screen and ${device.tablet} {
    width: 135px;
    height: 150px;
    padding: 15px;
  }
`;

const GridTitle = styled.div`
  font-family: Inter;
  text-align: left;
  font-weight: 600;
  font-size: 24px;

  vertical-align: middle;
  color: #0c3f89;
  @media only screen and ${device.tablet} {
    font-size: 18px;
  }
`;

const GridDescription = styled.div`
  font-family: Inter;
  font-weight: 400;
  text-align: left;
  font-size: 16px;
  vertical-align: middle;
  color: #051a3a;
  @media only screen and ${device.tablet} {
    font-size: 12px;
    display: none;
  }
`;
const dataArray = [
  {
    logo: BrandAstraNavigator,
    title:
      window?.innerWidth < 768
        ? 'Decode Emotional Intelligence'
        : 'The BrandAstra Navigator',
    description:
      'BrandAstra decodes sentiments and emotions from data to deliver actionable insights at scale.',
  },
  {
    logo: HolisticView,
    title: 'Scan Multiple sources for a Holistic View',
    description:
      'Analyze data from social media, reviews, news, forums, blogs, and internal sources, all in one place.',
  },
  {
    logo: WhyTrends,
    title: 'Discover The ‘Why’ Behind Trends & Patterns',
    description:
      'Uncover what drives customer behaviour, operational trends, and market shifts.',
  },
  {
    logo: BenchMark,
    title: 'Benchmark Against Competitors',
    description:
      'Compare sentiment, identify threats, and find opportunities to stay ahead.',
  },
  {
    logo: Multichannel,
    title: 'Optimize Multichannel Performance & Budget',
    description:
      'Measure platform performance to identify what works and guide investments.',
  },
  {
    logo: GenAI,
    title: 'Generative AI for Visual Storytelling & Reporting',
    description:
      'Create AI-driven reports, dashboards, and insights ready for sharing.',
  },
  {
    logo: Publishing,
    title: 'Publishing',
    description:
      'An AI-powered hub for planning, optimizing, and publishing across digital channels.',
  },
  {
    logo: UnderstandLanguage,
    title: 'Real-Time Insights Across Languages',
    description:
      'Interpret sentiment, emotion, and tone across languages for deeper insights.',
  },
  {
    logo: EnterPriseCompatibility,
    title: 'Enterprise Compatibility',
    description:
      'Integrate BrandAstra with enterprise systems via APIs or custom channels.',
  },
];
const WhatDoesBrandAstraDo = () => {
  return (
    <>

      <Helmet>
        <title>BrandAstra's Solutions | AI Marketing & Sentiment Analysis Tool</title>
        <meta name="description" content="Monitor brand health, perform sentiment analysis, decode emotions, identify key influencers, and leverage Generative AI to build smart dashboards and reports for your business in real-time. With enterprise-grade API integration and customizable channel building, BrandAstra delivers real-time competitive analysis, trend forecasting, and consumer engagement across social media, e-commerce platforms, news outlets, and online forums." />
        <meta name="keywords" content="BrandAstra, social listening, AI insights" />
        <link rel="canonical" href="https://qa.brandastra.ai/solutions" />
      </Helmet>

      <Wrapper>
        <Title>What Does BrandAstra Do</Title>
        <GridContainer>
          {dataArray?.map((data, index) => {
            return (
              <IndividualGrid index={index}>
                <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
                  {data?.logo}
                </div>
                <GridTitle>{data?.title}</GridTitle>
                <GridDescription>{data?.description}</GridDescription>
              </IndividualGrid>
            );
          })}
        </GridContainer>
      </Wrapper>
    </>

  );
};
export default WhatDoesBrandAstraDo;
